import { Component, Input } from '@angular/core';
import { TotalBy } from '../../../../models/view-models';

@Component({
  selector: 'report-total-by-item',
  templateUrl: './total-by-item.component.html',
  styleUrls: ['./total-by-item.component.scss']
})
export class TotalByItemComponent {

  @Input("header") header: string = "";
  @Input("items") items: TotalBy[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
